import type { LinkProps } from "react-router";
import { Link } from "react-router";
import { cn } from "@/lib/utils";
import { usePreserveQuery } from "@/hooks/use-preserve-query";

interface UILinkProps extends LinkProps {
  preserveQuery?: boolean;
}
export const UILink = ({ className, preserveQuery = false, to, ...props }: UILinkProps) => {
  const preserveQueryFn = usePreserveQuery();
  const toWithQuery = preserveQuery ? preserveQueryFn(to) : to;
  return (
    <Link
      to={toWithQuery}
      className={cn(
        "font-medium text-info hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        className
      )}
      {...props}
    />
  );
};
